import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StructureArrow } from '../../../../../MyTeamBackofficeStyled';
import { getRootTeamMember } from '../../../../../myTeamBackOffice.actions';

import { Icon, IconStructureNavArrow } from '../../../../../../../styles/Icons';
import { color } from '../../../../../../../styles/GlobalStyles';
import { useAppSelector } from '../../../../../../../app/hooks';
import { StructureType } from '../../../../../myTeamBackOffice.constants';

export const GoUpArrowButton = () => {
  const dispatch = useDispatch();
  const { rootTeamMemberTrading } = useSelector(
    (store) => store.myTeamBackoffice
  );
  const { userInfo } = useAppSelector((state) => state.auth);

  if (!rootTeamMemberTrading) return null;

  // eslint-disable-next-line eqeqeq
  const isUpArrowDisabled = rootTeamMemberTrading?.id === userInfo?.user?.id;

  const goUp = () => {
    if (!isUpArrowDisabled) {
      dispatch(
        getRootTeamMember(
          rootTeamMemberTrading?.parentId,
          StructureType.TRADING
        )
      );
    }
  };

  return (
    <StructureArrow disabled={isUpArrowDisabled} onClick={goUp}>
      {/* {console.log(rootTeamMemberTrading)} */}
      {/* {console.log(userInfo)} */}
      <Icon
        color={
          !isUpArrowDisabled ? color.colors.neutral50 : color.colors.neutral100
        }>
        <IconStructureNavArrow />
      </Icon>
    </StructureArrow>
  );
};
